// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ActivityTypeSchema = z.enum(['USER_PROVIDED','DNS_BRUTEFORCE','REVERSE_DNS_LOOKUP','CERTIFICATE_ALT_SUBJECT','INTELLIGENCE','REVERSE_WHOIS','NAME_RESOLUTION','PORT_SCAN','SERVICE_FINGERPRINT','VULNERABILITY_SCAN','SOFTWARE_PROBING','SUBDOMAIN_ENUMERATION','DNS_RESOLUTION','SERVICE_PROBE','REVERSE_DNS','EXTERNAL_INTEGRATION_IMPORT'] as const);

export type ActivityTypeType = `${z.infer<typeof ActivityTypeSchema>}`

export default ActivityTypeSchema;
